import React from 'react';

/**
 * Componente de imagem customizada para exibir no formulário
 * @param {object} props
 * @returns {JSX.Element}
 */
export const FormImage = ({ schema }) => {
  const src = schema?.properties?.src?.const || '';
  const alt = schema?.properties?.alt?.const || '';
  const width = schema?.properties?.width?.const || '100%';
  const align = schema?.properties?.align?.const || 'left';

  return (
    <div style={{ textAlign: align }}>
      <img src={src} alt={alt} width={width} />
    </div>
  );
};
